<template>
  <q-img
    v-bind="$attrs"
    no-spinner
    fit="contain"
    position="center left"
    :src="imagePath"
  />
</template>

<script>
// MIRA is here!
export default {
  props: {
    type: {
      type: String,
      default: 'symbol',
      validator: (value) => {
        return ['horizontal', 'vertical', 'symbol'].includes(value)
      }
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imagePath () {
      return `mira/${this.type}/svg/${this.dark ? 'miraLight' : 'miraBlue'}.svg`
    }
  }
}
</script>
